import React, { useState } from "react";

// The SVGs exported from the Figma frames of Manage Groups as one list
// (progress/design_oko2-4230-4231/assets), inlined so each keeps its exact
// path, stroke and fill.

const Svg = ({ size = 24, children }) => (
  <svg
    aria-hidden="true"
    focusable="false"
    width={size}
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: "block", flexShrink: 0 }}
  >
    {children}
  </svg>
);

const stroke = (color) => ({ stroke: color, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" });

const INK = "#002E19";

export const InfoLucideIcon = () => (
  <Svg>
    <path
      d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      {...stroke(INK)}
    />
  </Svg>
);

export const PieChartIcon = () => (
  <Svg size={32}>
    <path d="M28.28 21.1867C27.4318 23.1926 26.105 24.9603 24.4158 26.3351C22.7266 27.7098 20.7264 28.6499 18.5899 29.073C16.4535 29.4962 14.2459 29.3895 12.1602 28.7624C10.0745 28.1353 8.17417 27.0068 6.62536 25.4755C5.07655 23.9443 3.92642 22.057 3.27551 19.9786C2.62461 17.9002 2.49275 15.694 2.89146 13.5528C3.29018 11.4117 4.20733 9.40084 5.56273 7.69604C6.91813 5.99124 8.67051 4.64442 10.6667 3.77333" {...stroke(INK)} />
    <path d="M29.3333 16C29.3333 14.249 28.9885 12.5152 28.3184 10.8976C27.6483 9.27988 26.6662 7.81002 25.4281 6.57191C24.19 5.3338 22.7201 4.35167 21.1024 3.68161C19.4848 3.01154 17.751 2.66667 16 2.66667V16H29.3333Z" {...stroke(INK)} />
  </Svg>
);

const TEXT_BUTTON_BLUE = "#524FC9";
const ACTION_BLUE = "#605DEC";

export const LessonEditIcon = () => (
  <Svg>
    <path d="M15 5L19 9M21.1739 6.81189C21.7026 6.28332 21.9997 5.56636 21.9998 4.81875C21.9999 4.07113 21.703 3.3541 21.1744 2.82539C20.6459 2.29668 19.9289 1.99961 19.1813 1.99951C18.4337 1.99942 17.7166 2.29632 17.1879 2.82489L3.84193 16.1739C3.60975 16.4054 3.43805 16.6904 3.34193 17.0039L2.02093 21.3559C1.99509 21.4424 1.99314 21.5342 2.01529 21.6217C2.03743 21.7092 2.08285 21.7891 2.14673 21.8529C2.21061 21.9167 2.29055 21.962 2.37809 21.984C2.46563 22.006 2.55749 22.0039 2.64393 21.9779L6.99693 20.6579C7.3101 20.5626 7.59511 20.392 7.82693 20.1609L21.1739 6.81189Z" {...stroke(TEXT_BUTTON_BLUE)} />
  </Svg>
);

export const LessonCopyIcon = () => (
  <Svg>
    <path d="M4 16C2.9 16 2 15.1 2 14V4C2 2.9 2.9 2 4 2H14C15.1 2 16 2.9 16 4M10 8H20C21.1046 8 22 8.89543 22 10V20C22 21.1046 21.1046 22 20 22H10C8.89543 22 8 21.1046 8 20V10C8 8.89543 8.89543 8 10 8Z" {...stroke(TEXT_BUTTON_BLUE)} />
  </Svg>
);

export const LessonTrashIcon = () => (
  <Svg>
    <path d="M3 6H21M19 6V20C19 21 18 22 17 22H7C6 22 5 21 5 20V6M8 6V4C8 3 9 2 10 2H14C15 2 16 3 16 4V6M10 11V17M14 11V17" {...stroke(ACTION_BLUE)} />
  </Svg>
);

// Both corner icons render white on the toggle's blue (the corners-out
// export's dark fill is not what the frame shows).
const ON_ACTION = "white";

export const ExpandIcon = () => (
  <Svg>
    <path d="M20.25 4.5V8.25C20.25 8.44891 20.171 8.63968 20.0303 8.78033C19.8897 8.92098 19.6989 9 19.5 9C19.3011 9 19.1103 8.92098 18.9697 8.78033C18.829 8.63968 18.75 8.44891 18.75 8.25V5.25H15.75C15.5511 5.25 15.3603 5.17098 15.2197 5.03033C15.079 4.88968 15 4.69891 15 4.5C15 4.30109 15.079 4.11032 15.2197 3.96967C15.3603 3.82902 15.5511 3.75 15.75 3.75H19.5C19.6989 3.75 19.8897 3.82902 20.0303 3.96967C20.171 4.11032 20.25 4.30109 20.25 4.5ZM8.25 18.75H5.25V15.75C5.25 15.5511 5.17098 15.3603 5.03033 15.2197C4.88968 15.079 4.69891 15 4.5 15C4.30109 15 4.11032 15.079 3.96967 15.2197C3.82902 15.3603 3.75 15.5511 3.75 15.75V19.5C3.75 19.6989 3.82902 19.8897 3.96967 20.0303C4.11032 20.171 4.30109 20.25 4.5 20.25H8.25C8.44891 20.25 8.63968 20.171 8.78033 20.0303C8.92098 19.8897 9 19.6989 9 19.5C9 19.3011 8.92098 19.1103 8.78033 18.9697C8.63968 18.829 8.44891 18.75 8.25 18.75ZM19.5 15C19.3011 15 19.1103 15.079 18.9697 15.2197C18.829 15.3603 18.75 15.5511 18.75 15.75V18.75H15.75C15.5511 18.75 15.3603 18.829 15.2197 18.9697C15.079 19.1103 15 19.3011 15 19.5C15 19.6989 15.079 19.8897 15.2197 20.0303C15.3603 20.171 15.5511 20.25 15.75 20.25H19.5C19.6989 20.25 19.8897 20.171 20.0303 20.0303C20.171 19.8897 20.25 19.6989 20.25 19.5V15.75C20.25 15.5511 20.171 15.3603 20.0303 15.2197C19.8897 15.079 19.6989 15 19.5 15ZM8.25 3.75H4.5C4.30109 3.75 4.11032 3.82902 3.96967 3.96967C3.82902 4.11032 3.75 4.30109 3.75 4.5V8.25C3.75 8.44891 3.82902 8.63968 3.96967 8.78033C4.11032 8.92098 4.30109 9 4.5 9C4.69891 9 4.88968 8.92098 5.03033 8.78033C5.17098 8.63968 5.25 8.44891 5.25 8.25V5.25H8.25C8.44891 5.25 8.63968 5.17098 8.78033 5.03033C8.92098 4.88968 9 4.69891 9 4.5C9 4.30109 8.92098 4.11032 8.78033 3.96967C8.63968 3.82902 8.44891 3.75 8.25 3.75Z" fill={ON_ACTION} />
  </Svg>
);

export const CollapseIcon = () => (
  <Svg>
    <path d="M14.25 9V4.5C14.25 4.30109 14.329 4.11032 14.4697 3.96967C14.6103 3.82902 14.8011 3.75 15 3.75C15.1989 3.75 15.3897 3.82902 15.5303 3.96967C15.671 4.11032 15.75 4.30109 15.75 4.5V8.25H19.5C19.6989 8.25 19.8897 8.32902 20.0303 8.46967C20.171 8.61032 20.25 8.80109 20.25 9C20.25 9.19891 20.171 9.38968 20.0303 9.53033C19.8897 9.67098 19.6989 9.75 19.5 9.75H15C14.8011 9.75 14.6103 9.67098 14.4697 9.53033C14.329 9.38968 14.25 9.19891 14.25 9ZM9 14.25H4.5C4.30109 14.25 4.11032 14.329 3.96967 14.4697C3.82902 14.6103 3.75 14.8011 3.75 15C3.75 15.1989 3.82902 15.3897 3.96967 15.5303C4.11032 15.671 4.30109 15.75 4.5 15.75H8.25V19.5C8.25 19.6989 8.32902 19.8897 8.46967 20.0303C8.61032 20.171 8.80109 20.25 9 20.25C9.19891 20.25 9.38968 20.171 9.53033 20.0303C9.67098 19.8897 9.75 19.6989 9.75 19.5V15C9.75 14.8011 9.67098 14.6103 9.53033 14.4697C9.38968 14.329 9.19891 14.25 9 14.25ZM19.5 14.25H15C14.8011 14.25 14.6103 14.329 14.4697 14.4697C14.329 14.6103 14.25 14.8011 14.25 15V19.5C14.25 19.6989 14.329 19.8897 14.4697 20.0303C14.6103 20.171 14.8011 20.25 15 20.25C15.1989 20.25 15.3897 20.171 15.5303 20.0303C15.671 19.8897 15.75 19.6989 15.75 19.5V15.75H19.5C19.6989 15.75 19.8897 15.671 20.0303 15.5303C20.171 15.3897 20.25 15.1989 20.25 15C20.25 14.8011 20.171 14.6103 20.0303 14.4697C19.8897 14.329 19.6989 14.25 19.5 14.25ZM9 3.75C8.80109 3.75 8.61032 3.82902 8.46967 3.96967C8.32902 4.11032 8.25 4.30109 8.25 4.5V8.25H4.5C4.30109 8.25 4.11032 8.32902 3.96967 8.46967C3.82902 8.61032 3.75 8.80109 3.75 9C3.75 9.19891 3.82902 9.38968 3.96967 9.53033C4.11032 9.67098 4.30109 9.75 4.5 9.75H9C9.19891 9.75 9.38968 9.67098 9.53033 9.53033C9.67098 9.38968 9.75 9.19891 9.75 9V4.5C9.75 4.30109 9.67098 4.11032 9.53033 3.96967C9.38968 3.82902 9.19891 3.75 9 3.75Z" fill={ON_ACTION} />
  </Svg>
);

let focusIconCount = 0;

// Figma's "Icon/Focus": a target with an arrow, its mask and clip given ids of
// their own per instance, since several cards show the icon at once.
export const FocusIcon = () => {
  const [suffix] = useState(() => (focusIconCount += 1));
  const clipId = `focus-icon-clip-${suffix}`;
  const maskId = `focus-icon-mask-${suffix}`;
  return (
    <Svg>
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
          {...stroke(INK)}
        />
        <path d="M14.5 9.5L18.5 5.5" strokeWidth="4" stroke="white" />
        <mask id={maskId} maskUnits="userSpaceOnUse" x="13.8489" y="-0.828427" width="11.3137" height="11.3137" fill="black">
          <rect fill="white" x="13.8489" y="-0.828427" width="11.3137" height="11.3137" />
          <path d="M20.2129 2L20.2129 4L22.2129 4L20.1616 6.05128L18.2129 6L18.1616 4.05128L20.2129 2Z" />
        </mask>
        <path
          d="M20.2129 2L18.1616 4.05128L18.2129 6L20.1616 6.05128L22.2129 4L20.2129 4L20.2129 2Z"
          strokeWidth="4"
          strokeLinejoin="round"
          stroke="white"
          mask={`url(#${maskId})`}
        />
        <path d="M12 12L19 5" strokeWidth="2" strokeLinecap="round" stroke={INK} />
        <path
          d="M20.2129 2L18.1616 4.05128L18.2129 6L20.1616 6.05128L22.2129 4L20.2129 4L20.2129 2Z"
          strokeWidth="2"
          strokeLinejoin="round"
          stroke={INK}
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  );
};
